__turbopack_context__.v({
  "continue_watching_row": "ContinueWatchingRow-module-scss-module___pLjKG__continue_watching_row",
  "continue_watching_row__splide_arrow": "ContinueWatchingRow-module-scss-module___pLjKG__continue_watching_row__splide_arrow",
  "continue_watching_row__title": "ContinueWatchingRow-module-scss-module___pLjKG__continue_watching_row__title",
  "splide__arrow": "ContinueWatchingRow-module-scss-module___pLjKG__splide__arrow",
  "splide__list": "ContinueWatchingRow-module-scss-module___pLjKG__splide__list",
  "splide__slide": "ContinueWatchingRow-module-scss-module___pLjKG__splide__slide",
});
